import * as serviceContext from '../services/serviceContext';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function getAccountData() {
    try {
        const response = await serviceContext.get("account/transaction/account", null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getCreditData() {
    try {
        const response = await serviceContext.get("account/transaction/credithistory", null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};
export async function getProfileData(user_id) {
    try {
        const response = await serviceContext.get("manage/profile", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};